import { createTheme } from "@mui/material/styles";
import config from "./config"
export const theme = createTheme(config)